var map = {
	"./Convention.png": "./public/assets/images/Convention.png",
	"./alert/balance.png": "./public/assets/images/alert/balance.png",
	"./alert/learning.png": "./public/assets/images/alert/learning.png",
	"./alert/social.png": "./public/assets/images/alert/social.png",
	"./avtar/11.jpg": "./public/assets/images/avtar/11.jpg",
	"./avtar/16.jpg": "./public/assets/images/avtar/16.jpg",
	"./avtar/3.jpg": "./public/assets/images/avtar/3.jpg",
	"./avtar/4.jpg": "./public/assets/images/avtar/4.jpg",
	"./avtar/7.jpg": "./public/assets/images/avtar/7.jpg",
	"./badge-back.jpeg": "./public/assets/images/badge-back.jpeg",
	"./badge-back_Expo2026.jpeg": "./public/assets/images/badge-back_Expo2026.jpeg",
	"./banner/1.jpg": "./public/assets/images/banner/1.jpg",
	"./banner/2.jpg": "./public/assets/images/banner/2.jpg",
	"./banner/3.jpg": "./public/assets/images/banner/3.jpg",
	"./big-lightgallry/01.jpg": "./public/assets/images/big-lightgallry/01.jpg",
	"./big-lightgallry/010.jpg": "./public/assets/images/big-lightgallry/010.jpg",
	"./big-lightgallry/011.jpg": "./public/assets/images/big-lightgallry/011.jpg",
	"./big-lightgallry/012.jpg": "./public/assets/images/big-lightgallry/012.jpg",
	"./big-lightgallry/013.jpg": "./public/assets/images/big-lightgallry/013.jpg",
	"./big-lightgallry/014.jpg": "./public/assets/images/big-lightgallry/014.jpg",
	"./big-lightgallry/015.jpg": "./public/assets/images/big-lightgallry/015.jpg",
	"./big-lightgallry/016.jpg": "./public/assets/images/big-lightgallry/016.jpg",
	"./big-lightgallry/02.jpg": "./public/assets/images/big-lightgallry/02.jpg",
	"./big-lightgallry/03.jpg": "./public/assets/images/big-lightgallry/03.jpg",
	"./big-lightgallry/04.jpg": "./public/assets/images/big-lightgallry/04.jpg",
	"./big-lightgallry/05.jpg": "./public/assets/images/big-lightgallry/05.jpg",
	"./big-lightgallry/06.jpg": "./public/assets/images/big-lightgallry/06.jpg",
	"./big-lightgallry/07.jpg": "./public/assets/images/big-lightgallry/07.jpg",
	"./big-lightgallry/08.jpg": "./public/assets/images/big-lightgallry/08.jpg",
	"./big-lightgallry/09.jpg": "./public/assets/images/big-lightgallry/09.jpg",
	"./big-masonry/1.jpg": "./public/assets/images/big-masonry/1.jpg",
	"./big-masonry/10.jpg": "./public/assets/images/big-masonry/10.jpg",
	"./big-masonry/11.jpg": "./public/assets/images/big-masonry/11.jpg",
	"./big-masonry/12.jpg": "./public/assets/images/big-masonry/12.jpg",
	"./big-masonry/13.jpg": "./public/assets/images/big-masonry/13.jpg",
	"./big-masonry/14.jpg": "./public/assets/images/big-masonry/14.jpg",
	"./big-masonry/15.jpg": "./public/assets/images/big-masonry/15.jpg",
	"./big-masonry/2.jpg": "./public/assets/images/big-masonry/2.jpg",
	"./big-masonry/3.jpg": "./public/assets/images/big-masonry/3.jpg",
	"./big-masonry/4.jpg": "./public/assets/images/big-masonry/4.jpg",
	"./big-masonry/5.jpg": "./public/assets/images/big-masonry/5.jpg",
	"./big-masonry/6.jpg": "./public/assets/images/big-masonry/6.jpg",
	"./big-masonry/7.jpg": "./public/assets/images/big-masonry/7.jpg",
	"./big-masonry/8.jpg": "./public/assets/images/big-masonry/8.jpg",
	"./big-masonry/9.jpg": "./public/assets/images/big-masonry/9.jpg",
	"./blog/12.png": "./public/assets/images/blog/12.png",
	"./blog/14.png": "./public/assets/images/blog/14.png",
	"./blog/4.jpg": "./public/assets/images/blog/4.jpg",
	"./blog/9.jpg": "./public/assets/images/blog/9.jpg",
	"./blog/blog-2.jpg": "./public/assets/images/blog/blog-2.jpg",
	"./blog/blog-3.jpg": "./public/assets/images/blog/blog-3.jpg",
	"./blog/blog-5.jpg": "./public/assets/images/blog/blog-5.jpg",
	"./blog/blog-6.jpg": "./public/assets/images/blog/blog-6.jpg",
	"./blog/blog-single.jpg": "./public/assets/images/blog/blog-single.jpg",
	"./blog/blog.jpg": "./public/assets/images/blog/blog.jpg",
	"./blog/comment.jpg": "./public/assets/images/blog/comment.jpg",
	"./blog/img.png": "./public/assets/images/blog/img.png",
	"./checkout/paypal.png": "./public/assets/images/checkout/paypal.png",
	"./customizer/1.png": "./public/assets/images/customizer/1.png",
	"./customizer/2.png": "./public/assets/images/customizer/2.png",
	"./customizer/3.png": "./public/assets/images/customizer/3.png",
	"./customizer/4.png": "./public/assets/images/customizer/4.png",
	"./customizer/5.png": "./public/assets/images/customizer/5.png",
	"./dashboard-2/balance-bg.png": "./public/assets/images/dashboard-2/balance-bg.png",
	"./dashboard-2/category/1.png": "./public/assets/images/dashboard-2/category/1.png",
	"./dashboard-2/category/2.png": "./public/assets/images/dashboard-2/category/2.png",
	"./dashboard-2/category/3.png": "./public/assets/images/dashboard-2/category/3.png",
	"./dashboard-2/dashboard-banner.gif": "./public/assets/images/dashboard-2/dashboard-banner.gif",
	"./dashboard-2/headphones.png": "./public/assets/images/dashboard-2/headphones.png",
	"./dashboard-2/office-work.gif": "./public/assets/images/dashboard-2/office-work.gif",
	"./dashboard-2/order/1.png": "./public/assets/images/dashboard-2/order/1.png",
	"./dashboard-2/order/2.png": "./public/assets/images/dashboard-2/order/2.png",
	"./dashboard-2/order/3.png": "./public/assets/images/dashboard-2/order/3.png",
	"./dashboard-2/order/4.png": "./public/assets/images/dashboard-2/order/4.png",
	"./dashboard-2/order/5.png": "./public/assets/images/dashboard-2/order/5.png",
	"./dashboard-2/order/sub-product/1.png": "./public/assets/images/dashboard-2/order/sub-product/1.png",
	"./dashboard-2/order/sub-product/10.png": "./public/assets/images/dashboard-2/order/sub-product/10.png",
	"./dashboard-2/order/sub-product/2.png": "./public/assets/images/dashboard-2/order/sub-product/2.png",
	"./dashboard-2/order/sub-product/3.png": "./public/assets/images/dashboard-2/order/sub-product/3.png",
	"./dashboard-2/order/sub-product/4.png": "./public/assets/images/dashboard-2/order/sub-product/4.png",
	"./dashboard-2/order/sub-product/5.png": "./public/assets/images/dashboard-2/order/sub-product/5.png",
	"./dashboard-2/order/sub-product/6.png": "./public/assets/images/dashboard-2/order/sub-product/6.png",
	"./dashboard-2/order/sub-product/7.png": "./public/assets/images/dashboard-2/order/sub-product/7.png",
	"./dashboard-2/order/sub-product/8.png": "./public/assets/images/dashboard-2/order/sub-product/8.png",
	"./dashboard-2/order/sub-product/9.png": "./public/assets/images/dashboard-2/order/sub-product/9.png",
	"./dashboard-2/product/1.png": "./public/assets/images/dashboard-2/product/1.png",
	"./dashboard-2/product/2.png": "./public/assets/images/dashboard-2/product/2.png",
	"./dashboard-2/product/3.png": "./public/assets/images/dashboard-2/product/3.png",
	"./dashboard-3/better.png": "./public/assets/images/dashboard-3/better.png",
	"./dashboard-3/bg-1.png": "./public/assets/images/dashboard-3/bg-1.png",
	"./dashboard-3/bg-2.png": "./public/assets/images/dashboard-3/bg-2.png",
	"./dashboard-3/bg-3.png": "./public/assets/images/dashboard-3/bg-3.png",
	"./dashboard-3/bg-balance.png": "./public/assets/images/dashboard-3/bg-balance.png",
	"./dashboard-3/bg.jpg": "./public/assets/images/dashboard-3/bg.jpg",
	"./dashboard-3/boostup1.png": "./public/assets/images/dashboard-3/boostup1.png",
	"./dashboard-3/boostup2.png": "./public/assets/images/dashboard-3/boostup2.png",
	"./dashboard-3/follower.png": "./public/assets/images/dashboard-3/follower.png",
	"./dashboard-3/mobile-img.png": "./public/assets/images/dashboard-3/mobile-img.png",
	"./dashboard-3/product/1.png": "./public/assets/images/dashboard-3/product/1.png",
	"./dashboard-3/product/2.png": "./public/assets/images/dashboard-3/product/2.png",
	"./dashboard-3/product/3.png": "./public/assets/images/dashboard-3/product/3.png",
	"./dashboard-3/product/4.png": "./public/assets/images/dashboard-3/product/4.png",
	"./dashboard-3/profile-bg.png": "./public/assets/images/dashboard-3/profile-bg.png",
	"./dashboard-3/profile.png": "./public/assets/images/dashboard-3/profile.png",
	"./dashboard-3/social/1.png": "./public/assets/images/dashboard-3/social/1.png",
	"./dashboard-3/social/2.png": "./public/assets/images/dashboard-3/social/2.png",
	"./dashboard-3/social/3.png": "./public/assets/images/dashboard-3/social/3.png",
	"./dashboard-3/social/4.png": "./public/assets/images/dashboard-3/social/4.png",
	"./dashboard-3/user.png": "./public/assets/images/dashboard-3/user.png",
	"./dashboard-3/wave.png": "./public/assets/images/dashboard-3/wave.png",
	"./dashboard/Banner.png": "./public/assets/images/dashboard/Banner.png",
	"./dashboard/Dashboard-Ecommerce-banner.gif": "./public/assets/images/dashboard/Dashboard-Ecommerce-banner.gif",
	"./dashboard/folder.png": "./public/assets/images/dashboard/folder.png",
	"./dashboard/folder1.png": "./public/assets/images/dashboard/folder1.png",
	"./dashboard/order-table/1.png": "./public/assets/images/dashboard/order-table/1.png",
	"./dashboard/order-table/2.png": "./public/assets/images/dashboard/order-table/2.png",
	"./dashboard/order-table/3.png": "./public/assets/images/dashboard/order-table/3.png",
	"./dashboard/order-table/4.png": "./public/assets/images/dashboard/order-table/4.png",
	"./dashboard/order-table/5.png": "./public/assets/images/dashboard/order-table/5.png",
	"./dashboard/order-table/6.png": "./public/assets/images/dashboard/order-table/6.png",
	"./dashboard/order-table/7.png": "./public/assets/images/dashboard/order-table/7.png",
	"./dashboard/order-table/8.png": "./public/assets/images/dashboard/order-table/8.png",
	"./dashboard/order-table/9.png": "./public/assets/images/dashboard/order-table/9.png",
	"./dashboard/profile.png": "./public/assets/images/dashboard/profile.png",
	"./dashboard/user/1.jpg": "./public/assets/images/dashboard/user/1.jpg",
	"./dashboard/user/10.jpg": "./public/assets/images/dashboard/user/10.jpg",
	"./dashboard/user/11.jpg": "./public/assets/images/dashboard/user/11.jpg",
	"./dashboard/user/12.jpg": "./public/assets/images/dashboard/user/12.jpg",
	"./dashboard/user/13.jpg": "./public/assets/images/dashboard/user/13.jpg",
	"./dashboard/user/2.jpg": "./public/assets/images/dashboard/user/2.jpg",
	"./dashboard/user/3.jpg": "./public/assets/images/dashboard/user/3.jpg",
	"./dashboard/user/4.jpg": "./public/assets/images/dashboard/user/4.jpg",
	"./dashboard/user/5.jpg": "./public/assets/images/dashboard/user/5.jpg",
	"./dashboard/user/6.jpg": "./public/assets/images/dashboard/user/6.jpg",
	"./dashboard/user/7.jpg": "./public/assets/images/dashboard/user/7.jpg",
	"./dashboard/user/8.jpg": "./public/assets/images/dashboard/user/8.jpg",
	"./dashboard/user/9.jpg": "./public/assets/images/dashboard/user/9.jpg",
	"./dashboard/widget-bg.png": "./public/assets/images/dashboard/widget-bg.png",
	"./details_close.png": "./public/assets/images/details_close.png",
	"./details_open.png": "./public/assets/images/details_open.png",
	"./ecommerce/01.jpg": "./public/assets/images/ecommerce/01.jpg",
	"./ecommerce/02.jpg": "./public/assets/images/ecommerce/02.jpg",
	"./ecommerce/03.jpg": "./public/assets/images/ecommerce/03.jpg",
	"./ecommerce/04.jpg": "./public/assets/images/ecommerce/04.jpg",
	"./ecommerce/05.jpg": "./public/assets/images/ecommerce/05.jpg",
	"./ecommerce/06.jpg": "./public/assets/images/ecommerce/06.jpg",
	"./ecommerce/07.jpg": "./public/assets/images/ecommerce/07.jpg",
	"./ecommerce/08.jpg": "./public/assets/images/ecommerce/08.jpg",
	"./ecommerce/09.jpg": "./public/assets/images/ecommerce/09.jpg",
	"./ecommerce/10.jpg": "./public/assets/images/ecommerce/10.jpg",
	"./ecommerce/11.jpg": "./public/assets/images/ecommerce/11.jpg",
	"./ecommerce/12.jpg": "./public/assets/images/ecommerce/12.jpg",
	"./ecommerce/13.jpg": "./public/assets/images/ecommerce/13.jpg",
	"./ecommerce/14.jpg": "./public/assets/images/ecommerce/14.jpg",
	"./ecommerce/15.jpg": "./public/assets/images/ecommerce/15.jpg",
	"./ecommerce/16.jpg": "./public/assets/images/ecommerce/16.jpg",
	"./ecommerce/Frame 34.svg": "./public/assets/images/ecommerce/Frame 34.svg",
	"./ecommerce/banner.jpg": "./public/assets/images/ecommerce/banner.jpg",
	"./ecommerce/card.png": "./public/assets/images/ecommerce/card.png",
	"./ecommerce/mastercard.png": "./public/assets/images/ecommerce/mastercard.png",
	"./ecommerce/order-trash.gif": "./public/assets/images/ecommerce/order-trash.gif",
	"./ecommerce/payment-option/card.svg": "./public/assets/images/ecommerce/payment-option/card.svg",
	"./ecommerce/payment-option/cash.svg": "./public/assets/images/ecommerce/payment-option/cash.svg",
	"./ecommerce/payment-option/wallet.svg": "./public/assets/images/ecommerce/payment-option/wallet.svg",
	"./ecommerce/paypal.png": "./public/assets/images/ecommerce/paypal.png",
	"./ecommerce/product-categories/drone.png": "./public/assets/images/ecommerce/product-categories/drone.png",
	"./ecommerce/product-categories/dvd.png": "./public/assets/images/ecommerce/product-categories/dvd.png",
	"./ecommerce/product-categories/headphone.png": "./public/assets/images/ecommerce/product-categories/headphone.png",
	"./ecommerce/product-categories/ipad.png": "./public/assets/images/ecommerce/product-categories/ipad.png",
	"./ecommerce/product-categories/keyboard.png": "./public/assets/images/ecommerce/product-categories/keyboard.png",
	"./ecommerce/product-categories/laptop.png": "./public/assets/images/ecommerce/product-categories/laptop.png",
	"./ecommerce/product-categories/mac-laptop.png": "./public/assets/images/ecommerce/product-categories/mac-laptop.png",
	"./ecommerce/product-categories/mouse.png": "./public/assets/images/ecommerce/product-categories/mouse.png",
	"./ecommerce/product-categories/phone.png": "./public/assets/images/ecommerce/product-categories/phone.png",
	"./ecommerce/product-categories/speaker.png": "./public/assets/images/ecommerce/product-categories/speaker.png",
	"./ecommerce/product-categories/watch-2.png": "./public/assets/images/ecommerce/product-categories/watch-2.png",
	"./ecommerce/product-categories/watch.png": "./public/assets/images/ecommerce/product-categories/watch.png",
	"./ecommerce/product-categories/wireless-headphone.png": "./public/assets/images/ecommerce/product-categories/wireless-headphone.png",
	"./ecommerce/product-png/product-table-1.png": "./public/assets/images/ecommerce/product-png/product-table-1.png",
	"./ecommerce/product-png/product-table-2.png": "./public/assets/images/ecommerce/product-png/product-table-2.png",
	"./ecommerce/product-png/product-table-3.png": "./public/assets/images/ecommerce/product-png/product-table-3.png",
	"./ecommerce/product-png/product-table-4.png": "./public/assets/images/ecommerce/product-png/product-table-4.png",
	"./ecommerce/product-png/product-table-5.png": "./public/assets/images/ecommerce/product-png/product-table-5.png",
	"./ecommerce/product-png/product-table-6.png": "./public/assets/images/ecommerce/product-png/product-table-6.png",
	"./ecommerce/product-table-1.png": "./public/assets/images/ecommerce/product-table-1.png",
	"./ecommerce/product-table-2.png": "./public/assets/images/ecommerce/product-table-2.png",
	"./ecommerce/product-table-3.png": "./public/assets/images/ecommerce/product-table-3.png",
	"./ecommerce/product-table-4.png": "./public/assets/images/ecommerce/product-table-4.png",
	"./ecommerce/product-table-5.png": "./public/assets/images/ecommerce/product-table-5.png",
	"./ecommerce/product-table-6.png": "./public/assets/images/ecommerce/product-table-6.png",
	"./ecommerce/product-table-7.png": "./public/assets/images/ecommerce/product-table-7.png",
	"./ecommerce/shop-categories/camera.png": "./public/assets/images/ecommerce/shop-categories/camera.png",
	"./ecommerce/shop-categories/dron.png": "./public/assets/images/ecommerce/shop-categories/dron.png",
	"./ecommerce/shop-categories/headphone.png": "./public/assets/images/ecommerce/shop-categories/headphone.png",
	"./ecommerce/shop-categories/keyboard.png": "./public/assets/images/ecommerce/shop-categories/keyboard.png",
	"./ecommerce/shop-categories/laptop-bag.png": "./public/assets/images/ecommerce/shop-categories/laptop-bag.png",
	"./ecommerce/shop-categories/laptop.png": "./public/assets/images/ecommerce/shop-categories/laptop.png",
	"./ecommerce/shop-categories/mouse.png": "./public/assets/images/ecommerce/shop-categories/mouse.png",
	"./ecommerce/shop-categories/phone.png": "./public/assets/images/ecommerce/shop-categories/phone.png",
	"./ecommerce/shop-categories/watch.png": "./public/assets/images/ecommerce/shop-categories/watch.png",
	"./ecommerce/visa.png": "./public/assets/images/ecommerce/visa.png",
	"./ecommerce/watch.png": "./public/assets/images/ecommerce/watch.png",
	"./email-template/10.jpg": "./public/assets/images/email-template/10.jpg",
	"./email-template/11.jpg": "./public/assets/images/email-template/11.jpg",
	"./email-template/3.png": "./public/assets/images/email-template/3.png",
	"./email-template/4.png": "./public/assets/images/email-template/4.png",
	"./email-template/invoice-1/1.png": "./public/assets/images/email-template/invoice-1/1.png",
	"./email-template/invoice-1/sign.png": "./public/assets/images/email-template/invoice-1/sign.png",
	"./email-template/invoice-3/bg-0.png": "./public/assets/images/email-template/invoice-3/bg-0.png",
	"./email-template/invoice-3/sign.png": "./public/assets/images/email-template/invoice-3/sign.png",
	"./email-template/pdfs.png": "./public/assets/images/email-template/pdfs.png",
	"./email/1.jpg": "./public/assets/images/email/1.jpg",
	"./email/2.jpg": "./public/assets/images/email/2.jpg",
	"./email/3.jpg": "./public/assets/images/email/3.jpg",
	"./faq/1.jpg": "./public/assets/images/faq/1.jpg",
	"./faq/2.jpg": "./public/assets/images/faq/2.jpg",
	"./faq/3.jpg": "./public/assets/images/faq/3.jpg",
	"./faq/4.jpg": "./public/assets/images/faq/4.jpg",
	"./faq/learning-1.png": "./public/assets/images/faq/learning-1.png",
	"./favicon.png": "./public/assets/images/favicon.png",
	"./forms/Bank-of-Baroda.png": "./public/assets/images/forms/Bank-of-Baroda.png",
	"./forms/MasterCard.png": "./public/assets/images/forms/MasterCard.png",
	"./forms/SCB.png": "./public/assets/images/forms/SCB.png",
	"./forms/authenticate.png": "./public/assets/images/forms/authenticate.png",
	"./forms/axis.png": "./public/assets/images/forms/axis.png",
	"./forms/credit-card.png": "./public/assets/images/forms/credit-card.png",
	"./forms/delivery.png": "./public/assets/images/forms/delivery.png",
	"./forms/email.png": "./public/assets/images/forms/email.png",
	"./forms/flags.png": "./public/assets/images/forms/flags.png",
	"./forms/hdfc.png": "./public/assets/images/forms/hdfc.png",
	"./forms/idbi.png": "./public/assets/images/forms/idbi.png",
	"./forms/qr-code.png": "./public/assets/images/forms/qr-code.png",
	"./forms/qr-scan.png": "./public/assets/images/forms/qr-scan.png",
	"./forms/rbl.png": "./public/assets/images/forms/rbl.png",
	"./forms/us-bank.png": "./public/assets/images/forms/us-bank.png",
	"./forms/user.png": "./public/assets/images/forms/user.png",
	"./gif/danger.gif": "./public/assets/images/gif/danger.gif",
	"./gif/dashboard-8/successful.gif": "./public/assets/images/gif/dashboard-8/successful.gif",
	"./gif/facebook.gif": "./public/assets/images/gif/facebook.gif",
	"./gif/instagram.gif": "./public/assets/images/gif/instagram.gif",
	"./gif/logout.gif": "./public/assets/images/gif/logout.gif",
	"./gif/online-shopping.gif": "./public/assets/images/gif/online-shopping.gif",
	"./gif/qr-scan.gif": "./public/assets/images/gif/qr-scan.gif",
	"./gif/whatapp.gif": "./public/assets/images/gif/whatapp.gif",
	"./hand.gif": "./public/assets/images/hand.gif",
	"./job-search/1.jpg": "./public/assets/images/job-search/1.jpg",
	"./job-search/2.jpg": "./public/assets/images/job-search/2.jpg",
	"./job-search/3.jpg": "./public/assets/images/job-search/3.jpg",
	"./job-search/4.jpg": "./public/assets/images/job-search/4.jpg",
	"./job-search/5.jpg": "./public/assets/images/job-search/5.jpg",
	"./job-search/6.jpg": "./public/assets/images/job-search/6.jpg",
	"./knowledgebase/bg_1.jpg": "./public/assets/images/knowledgebase/bg_1.jpg",
	"./landing/bg-footer.png": "./public/assets/images/landing/bg-footer.png",
	"./landing/demo-bg.png": "./public/assets/images/landing/demo-bg.png",
	"./lightgallry/01.jpg": "./public/assets/images/lightgallry/01.jpg",
	"./lightgallry/010.jpg": "./public/assets/images/lightgallry/010.jpg",
	"./lightgallry/011.jpg": "./public/assets/images/lightgallry/011.jpg",
	"./lightgallry/012.jpg": "./public/assets/images/lightgallry/012.jpg",
	"./lightgallry/013.jpg": "./public/assets/images/lightgallry/013.jpg",
	"./lightgallry/014.jpg": "./public/assets/images/lightgallry/014.jpg",
	"./lightgallry/015.jpg": "./public/assets/images/lightgallry/015.jpg",
	"./lightgallry/016.jpg": "./public/assets/images/lightgallry/016.jpg",
	"./lightgallry/02.jpg": "./public/assets/images/lightgallry/02.jpg",
	"./lightgallry/03.jpg": "./public/assets/images/lightgallry/03.jpg",
	"./lightgallry/04.jpg": "./public/assets/images/lightgallry/04.jpg",
	"./lightgallry/05.jpg": "./public/assets/images/lightgallry/05.jpg",
	"./lightgallry/06.jpg": "./public/assets/images/lightgallry/06.jpg",
	"./lightgallry/07.jpg": "./public/assets/images/lightgallry/07.jpg",
	"./lightgallry/08.jpg": "./public/assets/images/lightgallry/08.jpg",
	"./lightgallry/09.jpg": "./public/assets/images/lightgallry/09.jpg",
	"./lightgallry/default-skin.png": "./public/assets/images/lightgallry/default-skin.png",
	"./lightgallry/default-skin.svg": "./public/assets/images/lightgallry/default-skin.svg",
	"./login/1.jpg": "./public/assets/images/login/1.jpg",
	"./login/2.jpg": "./public/assets/images/login/2.jpg",
	"./login/3.jpg": "./public/assets/images/login/3.jpg",
	"./login/icon.png": "./public/assets/images/login/icon.png",
	"./login/login_bg.jpg": "./public/assets/images/login/login_bg.jpg",
	"./logo.PNG": "./public/assets/images/logo.PNG",
	"./logo/logo-icon-psf.png": "./public/assets/images/logo/logo-icon-psf.png",
	"./logo/logo-icon.png": "./public/assets/images/logo/logo-icon.png",
	"./logo/logo-psf-dark.png": "./public/assets/images/logo/logo-psf-dark.png",
	"./logo/logo-psf.PNG": "./public/assets/images/logo/logo-psf.PNG",
	"./logo/logo-psf1.png": "./public/assets/images/logo/logo-psf1.png",
	"./logo/logo-rounded.png": "./public/assets/images/logo/logo-rounded.png",
	"./logo/logo.png": "./public/assets/images/logo/logo.png",
	"./logo/logo_dark.png": "./public/assets/images/logo/logo_dark.png",
	"./masonry/1.jpg": "./public/assets/images/masonry/1.jpg",
	"./masonry/10.jpg": "./public/assets/images/masonry/10.jpg",
	"./masonry/11.jpg": "./public/assets/images/masonry/11.jpg",
	"./masonry/12.jpg": "./public/assets/images/masonry/12.jpg",
	"./masonry/13.jpg": "./public/assets/images/masonry/13.jpg",
	"./masonry/14.jpg": "./public/assets/images/masonry/14.jpg",
	"./masonry/15.jpg": "./public/assets/images/masonry/15.jpg",
	"./masonry/2.jpg": "./public/assets/images/masonry/2.jpg",
	"./masonry/3.jpg": "./public/assets/images/masonry/3.jpg",
	"./masonry/4.jpg": "./public/assets/images/masonry/4.jpg",
	"./masonry/5.jpg": "./public/assets/images/masonry/5.jpg",
	"./masonry/6.jpg": "./public/assets/images/masonry/6.jpg",
	"./masonry/7.jpg": "./public/assets/images/masonry/7.jpg",
	"./masonry/8.jpg": "./public/assets/images/masonry/8.jpg",
	"./masonry/9.jpg": "./public/assets/images/masonry/9.jpg",
	"./operators/airtel.png": "./public/assets/images/operators/airtel.png",
	"./operators/logos/airtel.png": "./public/assets/images/operators/logos/airtel.png",
	"./operators/logos/mtn.png": "./public/assets/images/operators/logos/mtn.png",
	"./operators/mtn.png": "./public/assets/images/operators/mtn.png",
	"./other-images/bg-profile.png": "./public/assets/images/other-images/bg-profile.png",
	"./other-images/boxbg.jpg": "./public/assets/images/other-images/boxbg.jpg",
	"./other-images/cart-img.jpg": "./public/assets/images/other-images/cart-img.jpg",
	"./other-images/coming-soon-bg.jpg": "./public/assets/images/other-images/coming-soon-bg.jpg",
	"./other-images/logo-login.png": "./public/assets/images/other-images/logo-login.png",
	"./other-images/logo_dark.png": "./public/assets/images/other-images/logo_dark.png",
	"./other-images/maintenance-bg.jpg": "./public/assets/images/other-images/maintenance-bg.jpg",
	"./other-images/mountain.jpg": "./public/assets/images/other-images/mountain.jpg",
	"./other-images/paypal.png": "./public/assets/images/other-images/paypal.png",
	"./other-images/profile-style-img.png": "./public/assets/images/other-images/profile-style-img.png",
	"./other-images/profile-style-img3.png": "./public/assets/images/other-images/profile-style-img3.png",
	"./other-images/receiver-img.jpg": "./public/assets/images/other-images/receiver-img.jpg",
	"./other-images/sea.jpg": "./public/assets/images/other-images/sea.jpg",
	"./other-images/sidebar-bg.jpg": "./public/assets/images/other-images/sidebar-bg.jpg",
	"./product/1.png": "./public/assets/images/product/1.png",
	"./product/10.png": "./public/assets/images/product/10.png",
	"./product/11.png": "./public/assets/images/product/11.png",
	"./product/12.png": "./public/assets/images/product/12.png",
	"./product/13.png": "./public/assets/images/product/13.png",
	"./product/14.png": "./public/assets/images/product/14.png",
	"./product/15.png": "./public/assets/images/product/15.png",
	"./product/2.png": "./public/assets/images/product/2.png",
	"./product/3.png": "./public/assets/images/product/3.png",
	"./product/4.png": "./public/assets/images/product/4.png",
	"./product/category/1.png": "./public/assets/images/product/category/1.png",
	"./product/category/2.png": "./public/assets/images/product/category/2.png",
	"./product/category/3.png": "./public/assets/images/product/category/3.png",
	"./product/category/4.png": "./public/assets/images/product/category/4.png",
	"./product/category/5.png": "./public/assets/images/product/category/5.png",
	"./product/category/purse.png": "./public/assets/images/product/category/purse.png",
	"./product/category/shoes.png": "./public/assets/images/product/category/shoes.png",
	"./product/category/toy.png": "./public/assets/images/product/category/toy.png",
	"./range-slider/sprite-skin-modern.png": "./public/assets/images/range-slider/sprite-skin-modern.png",
	"./scrollbar/fashion1.jpg": "./public/assets/images/scrollbar/fashion1.jpg",
	"./scrollbar/fashion2.jpg": "./public/assets/images/scrollbar/fashion2.jpg",
	"./scrollbar/fashion3.jpg": "./public/assets/images/scrollbar/fashion3.jpg",
	"./scrollbar/fashion4.jpg": "./public/assets/images/scrollbar/fashion4.jpg",
	"./scrollbar/fashion5.jpg": "./public/assets/images/scrollbar/fashion5.jpg",
	"./scrollbar/fashion6.jpg": "./public/assets/images/scrollbar/fashion6.jpg",
	"./search-not-found.png": "./public/assets/images/search-not-found.png",
	"./slider/1.jpg": "./public/assets/images/slider/1.jpg",
	"./slider/10.jpg": "./public/assets/images/slider/10.jpg",
	"./slider/11.jpg": "./public/assets/images/slider/11.jpg",
	"./slider/2.jpg": "./public/assets/images/slider/2.jpg",
	"./slider/3.jpg": "./public/assets/images/slider/3.jpg",
	"./slider/4.jpg": "./public/assets/images/slider/4.jpg",
	"./slider/5.jpg": "./public/assets/images/slider/5.jpg",
	"./slider/6.jpg": "./public/assets/images/slider/6.jpg",
	"./slider/7.jpg": "./public/assets/images/slider/7.jpg",
	"./slider/8.jpg": "./public/assets/images/slider/8.jpg",
	"./slider/9.jpg": "./public/assets/images/slider/9.jpg",
	"./social-app/post-1.png": "./public/assets/images/social-app/post-1.png",
	"./social-app/post-2.png": "./public/assets/images/social-app/post-2.png",
	"./social-app/post-3.png": "./public/assets/images/social-app/post-3.png",
	"./social-app/post-4.png": "./public/assets/images/social-app/post-4.png",
	"./social-app/post-5.png": "./public/assets/images/social-app/post-5.png",
	"./social-app/post-6.png": "./public/assets/images/social-app/post-6.png",
	"./social-app/post-7.png": "./public/assets/images/social-app/post-7.png",
	"./social-app/post-8.png": "./public/assets/images/social-app/post-8.png",
	"./social-app/post-9.png": "./public/assets/images/social-app/post-9.png",
	"./social-app/social-image.png": "./public/assets/images/social-app/social-image.png",
	"./social-app/timeline-1.png": "./public/assets/images/social-app/timeline-1.png",
	"./social-app/timeline-2.png": "./public/assets/images/social-app/timeline-2.png",
	"./social-app/timeline-3.png": "./public/assets/images/social-app/timeline-3.png",
	"./social-app/timeline-4.png": "./public/assets/images/social-app/timeline-4.png",
	"./start-conversion.jpg": "./public/assets/images/start-conversion.jpg",
	"./switch/1.jpg": "./public/assets/images/switch/1.jpg",
	"./switch/2.jpg": "./public/assets/images/switch/2.jpg",
	"./switch/3.jpg": "./public/assets/images/switch/3.jpg",
	"./switch/4.jpg": "./public/assets/images/switch/4.jpg",
	"./switch/5.jpg": "./public/assets/images/switch/5.jpg",
	"./switch/6.jpg": "./public/assets/images/switch/6.jpg",
	"./switch/7.jpg": "./public/assets/images/switch/7.jpg",
	"./switch/8.jpg": "./public/assets/images/switch/8.jpg",
	"./switch/square-gray.png": "./public/assets/images/switch/square-gray.png",
	"./switch/square.svg": "./public/assets/images/switch/square.svg",
	"./user/1.jpg": "./public/assets/images/user/1.jpg",
	"./user/10.jpg": "./public/assets/images/user/10.jpg",
	"./user/11.png": "./public/assets/images/user/11.png",
	"./user/12.png": "./public/assets/images/user/12.png",
	"./user/14.png": "./public/assets/images/user/14.png",
	"./user/15.png": "./public/assets/images/user/15.png",
	"./user/150x150.jpg": "./public/assets/images/user/150x150.jpg",
	"./user/16.png": "./public/assets/images/user/16.png",
	"./user/17.png": "./public/assets/images/user/17.png",
	"./user/18.png": "./public/assets/images/user/18.png",
	"./user/19.png": "./public/assets/images/user/19.png",
	"./user/2.jpg": "./public/assets/images/user/2.jpg",
	"./user/2.png": "./public/assets/images/user/2.png",
	"./user/20.png": "./public/assets/images/user/20.png",
	"./user/21.png": "./public/assets/images/user/21.png",
	"./user/22.png": "./public/assets/images/user/22.png",
	"./user/23.png": "./public/assets/images/user/23.png",
	"./user/24.png": "./public/assets/images/user/24.png",
	"./user/25.png": "./public/assets/images/user/25.png",
	"./user/26.png": "./public/assets/images/user/26.png",
	"./user/27.png": "./public/assets/images/user/27.png",
	"./user/28.png": "./public/assets/images/user/28.png",
	"./user/29.png": "./public/assets/images/user/29.png",
	"./user/3.jpg": "./public/assets/images/user/3.jpg",
	"./user/3.png": "./public/assets/images/user/3.png",
	"./user/30.png": "./public/assets/images/user/30.png",
	"./user/31.png": "./public/assets/images/user/31.png",
	"./user/32.png": "./public/assets/images/user/32.png",
	"./user/33.png": "./public/assets/images/user/33.png",
	"./user/34.png": "./public/assets/images/user/34.png",
	"./user/35.png": "./public/assets/images/user/35.png",
	"./user/38.png": "./public/assets/images/user/38.png",
	"./user/39.png": "./public/assets/images/user/39.png",
	"./user/4.jpg": "./public/assets/images/user/4.jpg",
	"./user/4.png": "./public/assets/images/user/4.png",
	"./user/40.png": "./public/assets/images/user/40.png",
	"./user/41.png": "./public/assets/images/user/41.png",
	"./user/42.png": "./public/assets/images/user/42.png",
	"./user/43.png": "./public/assets/images/user/43.png",
	"./user/44.png": "./public/assets/images/user/44.png",
	"./user/45.png": "./public/assets/images/user/45.png",
	"./user/46.png": "./public/assets/images/user/46.png",
	"./user/47.png": "./public/assets/images/user/47.png",
	"./user/49.png": "./public/assets/images/user/49.png",
	"./user/5.jpg": "./public/assets/images/user/5.jpg",
	"./user/50.png": "./public/assets/images/user/50.png",
	"./user/51.png": "./public/assets/images/user/51.png",
	"./user/52.png": "./public/assets/images/user/52.png",
	"./user/53.png": "./public/assets/images/user/53.png",
	"./user/54.png": "./public/assets/images/user/54.png",
	"./user/6.jpg": "./public/assets/images/user/6.jpg",
	"./user/7.jpg": "./public/assets/images/user/7.jpg",
	"./user/8.jpg": "./public/assets/images/user/8.jpg",
	"./user/9.jpg": "./public/assets/images/user/9.jpg",
	"./user/user-dp.png": "./public/assets/images/user/user-dp.png",
	"./user/user.png": "./public/assets/images/user/user.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/assets/images sync recursive ^\\.\\/.*$";